<template>

	<div>
		<div class="card shadow-sm mb-4">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">Existing Collections</h4>
			</div>
			<div class="card-body">

				<ul class="list-unstyled mt-3 mb-4">
					<li v-for="( collection, index ) in collectionList" :key="index">
						<router-link :to="'/nodes/'+ nodeId +'/projects/'+ projectId +'/collections/'+ collection.$id.split(':')[1] ">{{collection.title}} ({{collection.$id}})</router-link>
					</li>
				</ul>

				<button class="btn btn-primary" @click.prevent="loadCollections( true )"><i class="fas fa-sync-alt"></i> Refresh</button>

				<p class="mt-4 mb-0 text-muted"><small><strong>Upcoming:</strong> we will soon offer collection search and browsing capabilities.</small></p>

			</div>
		</div>
		
		<div class="card shadow-sm mb-4">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">Create New Collection</h4>
			</div>
			<div class="card-body">
				<form autocomplete="off">
					<div class="form-group">
						<label for="newCollection_name">Access Name</label>
						<input v-model="newCollectionName" type="text" class="form-control" id="newCollection_name" aria-describedby="newCollection_nameHelp" placeholder="Enter collection access name">
						<small id="newCollection_nameHelp" class="form-text text-muted">Access name of collection (e.g. "joe_collection"). Must be unique in this project.</small>
					</div>
					<div class="form-group">
						<label for="newCollection_title">Title</label>
						<input v-model="newCollection.title" type="text" class="form-control" id="newCollection_title" aria-describedby="newCollection_titleHelp" placeholder="Enter title">
						<small id="newCollection_titleHelp" class="form-text text-muted">Title (name) for this Collection (e.g. "Store Products")</small>
					</div>
					<div class="form-group">
						<label for="newCollection_desc">Description</label>
						<textarea v-model="newCollection.description" type="text" class="form-control" id="newCollection_desc" aria-describedby="newCollection_descHelp" placeholder="Enter description" rows="2"></textarea>
						<small id="newCollection_descHelp" class="form-text text-muted">Descriptive details (e.g. "This collection stored product entries.")</small>
					</div>

					<div class="form-group">
						<label for="newCollection_group">Collection Group (Optional)</label>
						<input v-model="newCollection.group" type="text" class="form-control" id="newCollection_group" aria-describedby="newCollection_groupHelp" placeholder="Enter group name (optional)">
						<small id="newCollection_groupHelp" class="form-text text-muted">This will be used to organize collections into groups (e.g. "Site Content")</small>
					</div>

					<div class="form-group">
						<label for="newCollection_type">Collection Type</label>
						<select v-model="newCollectionType" class="form-control" id="newCollection_type" aria-describedby="newCollection_typeHelp">
							<option value="">Data Storage (Default)</option>
							<option value="reference">Reference</option>
							<option value="reference.copy">Reference - with Local Copies</option>
							<option value="adapter">Custom Adapter (FUTURE)</option>
						</select>
						<small id="newCollection_typeHelp" class="form-text text-muted">Select the type of collection to be created.</small>
					</div>

					<template v-if="newCollection.$schema && newCollection.$schema.indexOf('.reference.') > 0">
						<h5 class="font-weight-normal">Reference Settings</h5>

						<div class="form-group">
							<label for="newCollection_id">Source Collection</label>
							<input v-model="newCollection.source" type="text" class="form-control" id="newCollection_source" aria-describedby="newCollection_sourceHelp" placeholder="<node-id>/<project>:<collection>">
							<small id="newCollection_sourceHelp" class="form-text text-muted">Collection address (global, project or local)</small>
						</div>
						<div class="form-group">
							<label for="newCollection_key">Reference Key (API Key)</label>
							<input v-model="newCollection.key" type="text" class="form-control" id="newCollection_key" aria-describedby="newCollection_keyHelp" placeholder="Enter reference API key">
							<small id="newCollection_keyHelp" class="form-text text-muted">Provide an API key which has access to the source collection.</small>
						</div>
					</template>

					<div class="mb-3" v-if="newCollection.$schema && newCollection.$schema.indexOf('.reference.') < 0">
						<h5 class="font-weight-normal">Schema Settings</h5>
						
						<div class="form-check">
							<input v-model="allowAllSchemas" type="checkbox" class="form-check-input" id="schemaRules_any">
							<label class="form-check-label" for="schemaRules_any">Allow ANY Schema <small class="text-muted">(this also allows objects with no schema at all)</small></label>
						</div>
						
						<div class="mt-2 pl-4" v-if="!allowAllSchemas">
							<h6>Enable Specific Base Schemas</h6>
							<!-- <div class="form-check mt-2">
								<input v-model="schemaRules['']" type="checkbox" class="form-check-input" id="schemaRules_none">
								<label class="form-check-label" for="schemaRules_none"><strong><em class="text-danger">none</em></strong> <small class="text-muted">(allow unstructured objects (without schemas) to be stored)</small></label>
							</div> -->
							<div v-if="schema.$id.split('.').length <= 2" v-for="(schema,index) in schemaList" :key="index" class="form-check">
								<input v-model="schemaRules[schema.$id.split(':')[1]]" type="checkbox" class="form-check-input" :id="'schemaRules_'+index">
								<label class="form-check-label" :for="'schemaRules_'+index"><strong>{{schema.$id.split(/\.|:/g)[1]}}</strong> <small class="text-muted">(allow this schema and all that are derived from it)</small></label>
							</div>
						</div>
						
					</div>

					<button class="btn btn-success mt-4" @click.prevent="createCollectionFromData"><i class="fas fa-save"></i> Create Collection</button>
				
				</form>
			</div>
		</div>

		<div class="card shadow-sm">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">Create New Collection (JSON)</h4>
			</div>
			<div class="card-body">
				<div id="editor"></div>
				<button class="btn btn-success mt-4" @click.prevent="createCollectionFromEditor"><i class="fas fa-star"></i> Create Collection</button>
			</div>
		</div>

	</div>

</template>

<script>

import 'ace-builds';
import 'ace-builds/webpack-resolver';

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import _ from 'lodash';

export default {
	name: "collections-view",
	props: [ 'nodeId', 'projectId' ],
	data() {
		return {
			newCollection:
			{
				$id : "",
				$schema : "sys:collection.",
				title : "",
				description : ""
			},
			newCollectionType : "",
			newCollectionName : "",
			collectionList : [],
			allowAllSchemas : true,
			schemaRules : { }
		};
	},
	components: { },
	watch:
	{
		allowAllSchemas( newVal, oldVal )
		{
			if( newVal != oldVal && newVal )
				this.$delete( this.newCollection, 'schemas' );
			else
				this.updateSchemaRules( this.schemaRules );
		},
		schemaRules:
		{
			deep : true,
			handler : function( newVal, oldVal )
			{
				this.updateSchemaRules( newVal )
			}
		},



		// schemaRules:
		// {
		// 	deep : true,
		// 	handler : function( newVal, oldVal )
		// 	{
		// 		this.$delete( this.newCollection, 'schemas' );
		// 		if( !newVal['*'] )
		// 		{
		// 			const newRules = {};
		// 			for( let match in newVal )
		// 			{
		// 				if( newVal[match] === true )
		// 					newRules[match] = { allow : true };
		// 			}
		// 			if( Object.keys( newRules ).length > 0 )
		// 				this.$set( this.newCollection, 'schemas', newRules );
		// 		}
		// 		this.editor.setValue( JSON.stringify( this.newCollection, null, 2 ), -1 );
		// 	}
		// },
		newCollectionName : function( newValue, oldValue )
		{
			this.newCollection.$id = this.projectId +":"+ newValue;
		},
		newCollectionType : function( newValue, oldValue )
		{
			this.newCollection.$schema = "sys:collection.";
			switch( newValue )
			{
			 	case 'reference':
					this.newCollection.$schema += "reference.";
					break;
				case 'reference.copy':
					this.newCollection.$schema += "reference.copy.";
					break;
			}
		},
		newCollection:
		{
			deep: true,
			handler: function( newValue, oldValue )
			{
				this.editor.setValue( JSON.stringify( this.newCollection, null, 2 ), -1 );
			}
		}
	},
	computed:
	{
		schemaList( )
		{
			return this.schemas( this.nodeId, this.projectId );
		},
		currentSessionAccount: function( )
		{
			try {
				let sessionGuid = this.activeSession( this.nodeId );
				let [ sNode, sKey ] = sessionGuid.split( "/" );
				let session = this.session( sessionGuid );
				let account = this.account( sNode, session.account );
				if( account )
					return account;
			} catch( err ) { }
			return { };	// No session.
		},
		...mapGetters( "schemas", {
			schemas: "schemas", // map STATE schemas/schemas to "schemas" AS A FUNCTION, which requires the nodeId and projectId as inputs!
		}),
		...mapGetters( "accounts", {
			account: "account",
		}),
		...mapGetters( "authentication", {
			activeSession: "activeSession",
			session: "session"
		}),
		...mapGetters( "collections", {
			collections: "collections", // map STATE collections/collections to "collections" AS A FUNCTION, which requires the nodeId and projectId as inputs!
		}),
	},
	methods:
	{
		updateSchemaRules( newRules )	// Called when an update is made on the INTERFACE.
		{
			this.$delete( this.newCollection, 'schemas' );
				
			if( this.allowAllSchemas !== true )
			{
				const updatedRules = {};
				for( let match in newRules )
				{
					if( newRules[match] === true )
						updatedRules[match] = { allow : true };
				}
				if( Object.keys( updatedRules ).length > 0 )
				{
					this.$set( this.newCollection, 'schemas', updatedRules );
				}
			}
		},
		getSchemas( )
		{
			return this.schemas( this.nodeId, this.projectId );
		},
		...mapActions({
			listCollections: "collections/list",
			createCollection: "collections/create",
			listSchemas: "schemas/list",
		}),
		async checkMySession( )
		{
			try {
				let sessionGuid = this.$store.getters['authentication/activeSession']( this.nodeId );
				return await this.$store.dispatch( 'authentication/checkSession', { nodeId : this.nodeId, sessionKey : sessionGuid } );
			} catch( err ) { console.error( err ); return null; }
		},
		getCollections( )
		{
			return this.collections( this.nodeId, this.projectId );
		},
		async loadCollections( nocache )
		{
			try {
				await this.listCollections( { nodeId : this.nodeId, projectId : this.projectId, nocache : nocache } );
				this.collectionList = this.collections( this.nodeId, this.projectId );
			} catch( err ) {
				if( err.response && ( err.response.status === 401 ) )
				{
					console.warn( "Session expired, invalid or missing.." );
					this.checkMySession( );
				}
				else
					throw err;
			}
		},
		async createCollectionFromData( )
		{
			// TODO: Set loading overlay
			await this.createNewCollection( this.newCollection );
		},
		async createCollectionFromEditor( )
		{
			// TODO: Set loading overlay
			let collection;

			try {
				collection = JSON.parse( this.editor.getValue( ) );
			} catch( err ) {
				alert( "Collection format issue:\n"+ err.message );
				console.error( err );
				return;
			}

			await this.createNewCollection( collection );
		},
		async createNewCollection( collection )
		{
			if( !collection.$id ) return alert( "Must define a collection ID ('$id' field)" );
			if( !collection.title ) return alert( "Must define a collection Title ('title' field)" );

			try {
				let result = await this.createCollection( { nodeId : this.nodeId, projectId : this.projectId, newCollection : collection } );
				if( !result.$id )
					throw new Error( "Result from collection creation came back without an ID!" );
				this.collectionList = this.collections( this.nodeId, this.projectId );
				let [ projectId, collectionName ] = result.$id.split( ":" );
				this.$router.push( { name : 'collection', params : { nodeId : this.nodeId, projectId, collectionName } } );
				// TODO: close loading overlay
			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "Collection creation failed:", err );
				alert( "Collection creation failed!\n"+ err.message );
				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
			}
		},
	},
	async created( )
	{
		this.collectionList = this.getCollections( );	// Get collections from cache.
		await this.loadCollections( true );	// Reload collections in the background to make sure we have the latest.
		await this.listSchemas( { nodeId : this.nodeId, projectId : this.projectId, nocache : true } );
	},
	async mounted( )
	{
		this.newCollection.$id = this.projectId +":<name>";
		try {
			this.editor = ace.edit( "editor", {
				mode: "ace/mode/json",
				theme: "ace/theme/tomorrow",	//"ace/theme/dracula",
				maxLines: 20,
				minLines: 5,
				fontSize: 14,
				showPrintMargin : false
			});
			this.editor.setValue( JSON.stringify( this.newCollection, null, 2 ), -1 );
		} catch( err ) { throw err; }
	}
};
</script>
<style scoped>
div#editor
{
	border: 1px solid #666;
}
h2 {
	font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/Collections.vue